<div
  *ngIf="!loading; else loadingTemplate"
  class="d-flex flex-grow flex-column content-block"
  style="padding-top: 20px"
>
  <div class="d-flex flex-shrink">
    <span style="font-size: 30px; font-weight: 300">{{ greeting }}</span>
  </div>

  <!--
  <div class="d-flex home-container">
    <div class="d-flex flex-column flex-grow">
      <div
        class="dx-card responsive-paddings"
        style="border-radius: 6px; margin-top: 40px"
      >
        {{ info }}
      </div>
    </div>

    <div class="d-flex flex-column flex-shrink news-container">
      <div
        class="d-flex"
        style="
          min-height: 47px;
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);
          padding: 5px 0 10px 0;
          align-items: end;
          margin-bottom: 20px;
        "
      >
        <span class="home-text" [style]="isSmall ? 'margin-right: 12px' : ''">
          {{ formatMessage("news") }}
        </span>
        <div
          *ngIf="isAllowedToCreateNewsElement && !(isSmall || isXSmall)"
          class="d-flex flex-grow"
        ></div>
        <dx-button
          *ngIf="isAllowedToCreateNewsElement"
          [hint]="formatMessage('news.add')"
          icon="plus"
          type="default"
          stylingMode="contained"
          style="border-radius: 31px; width: 31px; height: 31px"
          (onClick)="popupVisible = true"
        ></dx-button>
      </div>

      <div
        class="
          d-flex
          align-items-center
          justify-content-center
          text-center
          no-news-container
        "
        *ngIf="lastNewsletterIds.length === 0; else tiles"
      >
        <span class="no-news-text">{{ formatMessage("news.none") }}</span>
      </div>
      <ng-template #tiles>
        <div class="d-flex news-tile-container">
          <app-news-element-tile
            *ngFor="let newsletterId of lastNewsletterIds"
            [newsId]="newsletterId"
            [showDeleteIcon]="isAllowedToCreateNewsElement"
            (onDelete)="handleOnDelete($event)"
          ></app-news-element-tile>
        </div>
      </ng-template>
    </div>
  </div>
  -->
</div>

<ng-template #loadingTemplate>
  <div
    class="
      d-flex
      flex-grow flex-column
      content-block
      align-items-center
      justify-content-center
    "
  >
    <dx-load-indicator [visible]="loading"></dx-load-indicator>
  </div>
</ng-template>

<dx-toast
  [(visible)]="showToast"
  [type]="toastType"
  [message]="toastMessage"
></dx-toast>

<app-news-element-popup
  *ngIf="popupVisible"
  [(visible)]="popupVisible"
  (onSave)="handleNewsElementOnSave()"
  (onError)="handleNewsElementOnError()"
></app-news-element-popup>

<app-confirmation-dialog
  [(visible)]="showConfirmationPopup"
  [title]="formatMessage('news.delete.title')"
  [message]="formatMessage('news.delete.message')"
  [confirmButtonText]="formatMessage('delete')"
  icon="dx-icon-warning"
  iconColor="warning"
  (onConfirm)="executeDeleteOperation()"
></app-confirmation-dialog>
